import { render, staticRenderFns } from "./DudleyCity.vue?vue&type=template&id=04211fd4&scoped=true&"
import script from "./DudleyCity.vue?vue&type=script&lang=js&"
export * from "./DudleyCity.vue?vue&type=script&lang=js&"
import style0 from "./DudleyCity.vue?vue&type=style&index=0&id=04211fd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04211fd4",
  null
  
)

export default component.exports